import { render } from "./FText.vue?vue&type=template&id=d97b6d6e"
import script from "./FText.vue?vue&type=script&lang=js"
export * from "./FText.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__